import { WindowMetrics } from "../utilities/window-metrics.js";

export class AhusOverview {
    constructor(parameters) {
        var t = this;

        let root = document.documentElement;
        // let's move the red Triggers div to tuck under 
        // the gray callout by updating the css variables 
        function overlapCallout() {
            var calloutHeight = document.querySelector('.callout').getBoundingClientRect().height,
                extraPadding,
                ahusoverviewMargin = (calloutHeight / 2);

            if (WindowMetrics.isMobile()) {
                extraPadding = 60;
            }
            else {
                extraPadding = 75;
            }
            root.style.setProperty('--ahusoverview-margin', '-' + ahusoverviewMargin + 'px');
            root.style.setProperty('--ahusoverview-padding', ahusoverviewMargin + extraPadding + 'px');
        };

        window.addEventListener('DOMContentLoaded', (event) => {
            overlapCallout();
        });

        window.addEventListener('resize', (event) => {
            overlapCallout();
        });

    }
}